'use es6';

import Raven from 'raven-js';
import { fileAttachmentIdsInMessage } from 'conversations-message-history/common-message-format/operators/fileAttachmentIdsInMessage';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { dataFetchingClient } from '../../data-fetching-client/dataFetchingClient';
import { RESOLVE_ATTACHMENTS_QUERY } from '../hooks/useResolveAttachments';
import { resolveAttachmentsSucceeded, resolveAttachmentsFailed } from '../constants/resolvedAttachmentsActionTypes';
import { buildResolvedAttachmentsMapFromResponse } from '../operators/buildResolvedAttachmentsMapFromResponse';
export const resolveAttachmentsForMessage = ({
  message,
  threadId
}) => (dispatch, getState) => {
  const fileIds = fileAttachmentIdsInMessage(message);
  if (!fileIds.size) {
    return Promise.resolve();
  }
  const sessionId = getSessionId(getState());
  return dataFetchingClient.query({
    query: RESOLVE_ATTACHMENTS_QUERY,
    variables: {
      fileIds,
      sessionId,
      threadId
    }
  }).then(result => {
    dispatch(resolveAttachmentsSucceeded({
      fileIds,
      resolvedAttachments: buildResolvedAttachmentsMapFromResponse(result.data.resolveAttachments)
    }));
  }).catch(error => {
    dispatch(resolveAttachmentsFailed({
      fileIds
    }));
    Raven.captureException(error);
  });
};